<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-10 13:28:50
 * @LastEditTime: 2019-09-20 15:58:21
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id='page_Container'>
        <div class="page">
            <!--导航栏-->
            <!-- <navigation title="交易成功"/> -->
            <div id="main-container" class="main-container" >
                <div class='successHeader'>
                    <img :src="rightImg" alt="">
                    <h4>评论成功</h4>
                    <p>感谢您的评价</p>
                </div>
                <div class='btnStyle'>
                    <div style='margin:30px auto 10px auto;width:80%;'>
                        <van-button round type="danger" size="large" @click='returnFn'>返回首页</van-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            rightImg: require('../assets/img/myCenter/right.png')
        };
    },
    esvReady() {
        document.title = '交易成功';
    },
    esvBack(backFn) {
        // 阻止系统返回键
        backFn && backFn(false);
    },
    methods: {
        returnFn() {
            this.esvBackPage(8);
            // this.esvOpenPage('OPHomenew');
        }
    }
};
</script>
<style lang="scss" scoped>
.successHeader{
    background:#fff;
    padding:50px 0;
    text-align: center;
    img{
        width:65px;
    }
    h4{
        font-size: 20px;
        margin:10px 0;
    }
    p{
        font-size: 14px;
        color:#999;
    }
}
.btnStyle{

}
</style>
